import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import moment from 'moment';
import { 
  AWARD_LIST,
  AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT,
  AWARD_ADD,
  AWARD_DETAIL,
  AWARD_UPDATE,
  AWARD_UPLOAD_SET
} from '../actions';
import {
  AwardListSuccess,
  AwardListError,
  AwardSearchDeliveryOrderLineLotSuccess,
  AwardSearchDeliveryOrderLineLotError,
  AwardAddSuccess,
  AwardAddError,
  AwardDetailSuccess,
  AwardDetailError,
  AwardUpdateSuccess,
  AwardUpdateError,
  AwardUploadSetSuccess,
  AwardUploadSetError
} from '../actions';
 
export function* watchAwardList() {
  yield takeEvery(AWARD_LIST, onAwardList);
}

export function* watchAwardSearchDeliveryOrderLineLot() {
  yield takeEvery(AWARD_SEARCH_DELIVERY_ORDER_LINE_LOT, onAwardSearchDeliveryOrderLineLot);
}

export function* watchAwardAdd() {
  yield takeEvery(AWARD_ADD, onAwardAdd);
}

export function* watchAwardDetail() {
  yield takeEvery(AWARD_DETAIL, onAwardDetail);
}

export function* watchAwardUpdate() {
  yield takeEvery(AWARD_UPDATE, onAwardUpdate);
}

export function* watchAwardUpload() {
  yield takeEvery(AWARD_UPLOAD_SET, onAwardUpload);
}

const onAwardListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'award/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAwardUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'award/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAwardSearchDeliveryOrderLineLotAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line_lot', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAwardAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'award/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAwardDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'award/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAwardUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/award/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_awards/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_awards/'});
      });
    });
  });
};


function* onAwardList(data) {
  try {
    const response = yield call(onAwardListAsync, data.payload);
    yield put(AwardListSuccess(response.data));
  } catch (error) {
    yield put(AwardListError(error));
  }
}

function* onAwardSearchDeliveryOrderLineLot(data) {
  try {
    const response = yield call(onAwardSearchDeliveryOrderLineLotAsync, data.payload);
    yield put(AwardSearchDeliveryOrderLineLotSuccess(response.data));
  } catch (error) {
    yield put(AwardSearchDeliveryOrderLineLotError(error));
  }
}

function* onAwardAdd(data) {
  try {
      const response = yield call(onAwardAddAsync, data);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AwardAddSuccess(response.data));
  } catch (error) {
      yield put(AwardAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onAwardDetail(data) {
  try {
    const response = yield call(onAwardDetailAsync, data.payload);
    yield put(AwardDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AwardDetailError(error));
  }
}

function* onAwardUpdate(data) {
  try {
      const response = yield call(onAwardUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AwardUpdateSuccess(response.data));
  } catch (error) {
      yield put(AwardUpdateError(error));
  }
}

function* onAwardUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onAwardUploadAsync, file);
    if(response.message ==='success'){
      yield put(AwardUploadSetSuccess(response));
    }
    else{
      yield put(AwardUploadSetError(response));
    }
  } catch (error) {
    yield put(AwardUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchAwardList),
    fork(watchAwardSearchDeliveryOrderLineLot),
    fork(watchAwardAdd),
    fork(watchAwardDetail),
    fork(watchAwardUpdate),
    fork(watchAwardUpload),
  ]);
} 